import { useEffect, useState } from "react";

export function useIsDesktop(min = 1024) {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= min : false
  );
  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${min}px)`);
    const onChange = () => setIsDesktop(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [min]);
  return isDesktop;
}
